/**
 * API base for JSON endpoints.
 * On anuyog.co use same-origin ('' ) so .htaccess api-proxy.php can forward to admin
 * without browser CORS failures. Images still use REACT_APP_MEDIA_BASE_URL → admin.
 */
export function getApiBaseUrl() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (/^(www\.)?anuyog\.co$/i.test(host)) {
      return '';
    }
  }

  const fromEnv = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
  if (fromEnv) return fromEnv;

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://127.0.0.1:8000';
    }
  }

  return 'https://admin.anuyog.co';
}

/** Join API base + path without double slashes. */
export function apiUrl(path) {
  const base = getApiBaseUrl();
  const normalized = String(path || '').replace(/^\/+/, '');
  return base ? `${base}/${normalized}` : `/${normalized}`;
}
